import Axios from "./interceptor";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/api";

const putPSDetails = async (data) => {
  const response = await Axios.put(
    `${API_URL}/CarePlanWizardDetail/UpdatePersonalDetails`,
    data,
  );
  return response.data;
};

export { putPSDetails };
